// ===========================================
// ADMIN INPUT COMPONENT
// ===========================================

import { forwardRef, type InputHTMLAttributes } from 'react';
import { clsx } from 'clsx';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  label?: string;
}

/**
 * Reusable input component for admin forms
 * Supports error display and labels
 */
export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, error, label, ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="mb-1.5 block text-xs font-semibold text-slate-600">
            {label}
          </label>
        )}
        <input
          ref={ref}
          className={clsx(
            'w-full rounded-xl border border-slate-200 bg-white px-4 py-3',
            'text-sm text-slate-900 shadow-sm outline-none transition',
            'placeholder:text-slate-400',
            'focus:border-brand-500 focus:ring-2 focus:ring-brand-200',
            error && 'border-red-400 focus:border-red-500 focus:ring-red-200',
            className
          )}
          {...props}
        />
        {error && <p className="mt-2 text-xs text-red-500">{error}</p>}
      </div>
    );
  }
);

Input.displayName = 'Input';
